export type LivePlaybackPollingContext = {
  readonly isEvergreen: boolean;
  readonly isYouTube: boolean;
  readonly hasLivePlaybackUrl: boolean;
};

/**
 * On relance `/playback` seulement en attendant le flux HLS d'un live natif. Un live YouTube n'en
 * aura jamais (le lecteur lit `youtubeUrl` sur la session) : le relancer tournerait tout le live.
 */
export function shouldPollLivePlayback({
  isEvergreen,
  isYouTube,
  hasLivePlaybackUrl,
}: LivePlaybackPollingContext) {
  return !isEvergreen && !isYouTube && !hasLivePlaybackUrl;
}
